import React, { createContext, useContext, useEffect, useState } from "react";
import instance from "../Services/AxiosConfig";

const defaultConfig = {
    showStakingLeaderboard: false,
    showRoadmapAndPartners: true,
    showArticlesList: false,
    showZealyWidget: false,
    zealyQuestId: "",
    homeBannerText: "",
    homeBannerImageUrl: "",
    showUpcomingAuctions: true,
    showUpcomingAuctionsDescription: false,
    showHeaderSoundButton: true,
};

const UIConfigContext = createContext(undefined);

export const UIConfigProvider = ({ children }) => {
    const [uiConfig, setUiConfig] = useState(defaultConfig);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchConfig = async () => {
        try {
            setIsLoading(true);
            setError(null);
            const response = await instance.get("/api/utils/ui-config");
            setUiConfig(response.data);
            // console.log("response.data", response.data);
        } catch (err) {
            console.error("Failed to fetch UI configuration:", err);
            setError("Failed to load UI configuration");
            // Keep using default config on error
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchConfig();
    }, []);

    return (
        <UIConfigContext.Provider
            value={{
                uiConfig,
                isLoading,
                error,
                refetchConfig: fetchConfig,
            }}
        >
            {children}
        </UIConfigContext.Provider>
    );
};

// Custom hook to use the UI config
export const useUIConfig = () => {
    const context = useContext(UIConfigContext);
    if (context === undefined) {
        throw new Error("useUIConfig must be used within a UIConfigProvider");
    }
    return context;
};
